module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-rc.46-67.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.0-rc.46.md
// module id = 485
// module chunks = 372